module.exports = __webpack_public_path__ + "static/media/S (76).a9a027bc.jpg";